// This file was auto-generated by Fern from our API Definition.
/**
 * Where one outbound message is in its life. CREATED, not PENDING: the row
 * is inserted before the post is attempted.
 */
export const ChannelDeliveryState = {
    Created: "created",
    Sent: "sent",
    Failed: "failed",
    Abandoned: "abandoned",
    Held: "held",
};
